export default __webpack_public_path__ + "static/layout-example-light-b869cc0688073a4e4546bc50612ae793.png";